import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=30588f22&scoped=true&"
import script from "./GroupDetail.vue?vue&type=script&lang=ts&"
export * from "./GroupDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=30588f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30588f22",
  null
  
)

export default component.exports